import React from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';

/**
 * ConditionalNavbar - Only shows Navbar on authenticated pages
 * Hides Navbar on login and register pages
 */
const ConditionalNavbar = () => {
  const location = useLocation();
  const publicRoutes = ['/login', '/register'];
  const isPublicRoute = publicRoutes.includes(location.pathname);

  // Don't show navbar on public routes
  if (isPublicRoute) {
    return null;
  }

  return <Navbar />;
};

export default ConditionalNavbar;



